var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5V17.5M7 8.5H2.59961C2.03956 8.5 1.75981 8.5 1.5459 8.60899C1.35774 8.70487 1.20487 8.85774 1.10899 9.0459C1 9.25981 1 9.54004 1 10.1001V17.5H7M7 8.5V3.1001C7 2.54004 7 2.25981 7.10899 2.0459C7.20487 1.85774 7.35774 1.70487 7.5459 1.60899C7.75981 1.5 8.03956 1.5 8.59961 1.5H11.3996C11.9597 1.5 12.2403 1.5 12.4542 1.60899C12.6423 1.70487 12.7948 1.85774 12.8906 2.0459C12.9996 2.25981 13 2.54005 13 3.1001V5.5M7 17.5H13M13 17.5L19 17.5001V7.1001C19 6.54005 18.9996 6.25981 18.8906 6.0459C18.7948 5.85774 18.6429 5.70487 18.4548 5.60899C18.2409 5.5 17.9601 5.5 17.4 5.5H13M13 17.5V5.5",
    stroke: "#636980",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d742d92d8fa27eea7343c9992e505908.svg";
export { ForwardRef as ReactComponent };